module.exports = __webpack_public_path__ + "assets/img/4-mobile.e605f921.png";